import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./SierraChat.module.css";
import "./SierraWidget.css";
import { ProgressIndicator } from "@asosteam/asos-web-component-library-progress-indicator";
import { sdk } from "@asosteam/asos-web-customer-care-chatbot-sdk";
import noticeError from "src/app/utilities/noticeError";
import { sierraChatTimeoutAction } from "src/app/utilities/sierraChat";
import { cleanupNotificationHandler } from "./utils/onAgentMessageEnd";
import { getSierraConfig } from "./utils/getSierraConfig";

export const SierraChat = ({ setLoadError, setShow }) => {
  const [loading, setLoading] = useState(true);

  const toggleChatModal = () => {
    if (window.sierra) {
      window.sierra.openChatModal();

      setLoading(false);
    } else {
      const initError = new Error("Sierra Chat: init error.");
      noticeError(initError);
      setLoadError(initError);
    }
  };

  useEffect(() => {
    let timeout;

    const initSierraSDK = async () => {
      if (!window.sierra) {
        try {
          const config = await getSierraConfig(toggleChatModal);
          const chatbot = sdk(config);
          await chatbot.get();
          timeout = sierraChatTimeoutAction(setShow, setLoadError);
        } catch (error) {
          noticeError(error);
          setShow(false);
          setLoadError(error);
        }
      }
    };

    initSierraSDK();

    return () => {
      clearTimeout(timeout);
      cleanupNotificationHandler();
    };
  }, []);

  return (
    <>
      {loading && (
        <div className={styles.loader}>
          <ProgressIndicator size="large" progressMessage="loading" />
        </div>
      )}
      <div
        id="sierra-chat-container"
        data-sierra-chat-container
        className={styles.sierraChatContainer}
        data-testid="sierra-chat-container"
      ></div>
    </>
  );
};

SierraChat.propTypes = {
  setLoadError: PropTypes.func,
  setShow: PropTypes.func,
};
